import {PluginListenerHandle} from '@capacitor/core';
import {DataWedge, ScanListenerEvent} from 'capacitor-datawedge';
import {defineStore} from 'pinia';

export const useScanner = defineStore('scanner', () => {
  let removeDataWedgeListener: PluginListenerHandle | null = null;

  async function removeScanListener() {
    await removeDataWedgeListener?.remove();
    removeDataWedgeListener = null;
  }

  return {
    async addScanListener(scanListener: (event: ScanListenerEvent) => void) {
      await removeScanListener();
      removeDataWedgeListener = await DataWedge.addListener('scan', scanListener);
    },
    removeScanListener,
  };
});
